<div *ngIf="show" class="fixed inset-0 z-[100] flex items-center justify-center bg-black bg-opacity-50 p-4" (click)="close()">
  <div class="bg-white dark:bg-gray-800 rounded-lg shadow-xl max-w-2xl w-full p-6 max-h-[90vh] overflow-y-auto" (click)="$event.stopPropagation()">
    <div class="flex items-center justify-between mb-6">
      <h3 class="text-2xl font-bold text-gray-900 dark:text-white">
        {{ formData.id ? 'Edit Customer' : 'New Customer' }}
      </h3>
      <button (click)="close()" class="p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-colors">
        <svg class="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>

    <div class="space-y-4">
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Name *</label>
          <input 
            type="text" 
            [(ngModel)]="formData.name" 
            class="w-full px-4 py-2 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-primary-500" 
            placeholder="Customer name" 
            required 
          />
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Phone</label>
          <input 
            type="tel" 
            [(ngModel)]="formData.phone" 
            class="w-full px-4 py-2 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-primary-500" 
            placeholder="Phone number" 
          />
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Email</label>
          <input 
            type="email" 
            [(ngModel)]="formData.email" 
            class="w-full px-4 py-2 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-primary-500" 
            placeholder="Email address" 
          />
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">GSTIN</label>
          <input 
            type="text" 
            [(ngModel)]="formData.gstin" 
            class="w-full px-4 py-2 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-primary-500" 
            placeholder="GSTIN number" 
          />
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">State</label>
          <input 
            type="text" 
            [(ngModel)]="formData.state" 
            class="w-full px-4 py-2 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-primary-500" 
            placeholder="State" 
          />
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">State Code</label>
          <input 
            type="text" 
            [(ngModel)]="formData.state_code" 
            class="w-full px-4 py-2 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-primary-500" 
            placeholder="State code" 
            maxlength="10" 
          />
        </div>
        <div class="md:col-span-2">
          <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Address</label>
          <textarea 
            [(ngModel)]="formData.address" 
            rows="3" 
            class="w-full px-4 py-2 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-primary-500" 
            placeholder="Customer address"
          ></textarea>
        </div>
      </div>
      <div class="flex items-center gap-2">
        <input 
          type="checkbox" 
          [(ngModel)]="formData.is_active" 
          [checked]="formData.is_active === 1" 
          (change)="formData.is_active = $any($event.target).checked ? 1 : 0" 
          id="customer-active" 
          class="w-4 h-4 text-primary-600 rounded focus:ring-primary-500" 
        />
        <label for="customer-active" class="text-sm text-gray-700 dark:text-gray-300">Active</label>
      </div>
      <div class="flex items-center gap-2">
        <input
          type="checkbox"
          [(ngModel)]="formData.is_temporary"
          [checked]="formData.is_temporary === 1"
          (change)="formData.is_temporary = $any($event.target).checked ? 1 : 0"
          id="customer-temporary"
          class="w-4 h-4 text-primary-600 rounded focus:ring-primary-500"
        />
        <label for="customer-temporary" class="text-sm text-gray-700 dark:text-gray-300">
          Temporary customer (skip balance/transaction maintenance)
        </label>
      </div>
    </div>

    <div class="flex gap-3 mt-6">
      <app-action-icon
        *ngIf="formData.id"
        action="delete"
        label="Delete customer"
        (actionClick)="delete()"
      ></app-action-icon>
      <div class="flex gap-3 ml-auto">
        <button 
          (click)="close()" 
          class="px-4 py-2 bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 rounded-lg font-semibold hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors"
        >
          Cancel
        </button>
        <button 
          (click)="save()" 
          [disabled]="isSaving"
          class="px-4 py-2 bg-primary-600 hover:bg-primary-700 disabled:bg-gray-400 text-white rounded-lg font-semibold transition-colors"
        >
          {{ isSaving ? 'Saving...' : (formData.id ? 'Update' : 'Create') }}
        </button>
      </div>
    </div>
  </div>
</div>
